import makeApiRequest from './makeApiRequest';

const getCbsSignature = () => {
	const postApiRequest = makeApiRequest('POST');

	const getToken = async (apiBase: string, body: any, version: string) => postApiRequest(`${apiBase}/api/cyber-source/signatures/${version}`, body);

	return [getToken];
};

export default getCbsSignature;
